export default {"src":"/_next/static/media/logo.3033c75e.svg","height":74,"width":375,"blurWidth":0,"blurHeight":0};